export const coursesDataVersion = "1.3";
